/**
 * Черновик неотправленного сообщения (MVP_TECH_RFC §22).
 *
 * `sessionStorage` здесь разрешён явно: это набранный текст, а не секрет.
 * Ключ содержит id сессии — после сброса подбора черновик прошлого диалога
 * не всплывает в новом.
 */

const PREFIX = 'carviq.chat-draft:';

export function readDraft(sessionId: string): string {
  try {
    return sessionStorage.getItem(PREFIX + sessionId) ?? '';
  } catch {
    // Приватный режим Safari запрещает доступ к хранилищу: чат работает и так.
    return '';
  }
}

export function saveDraft(sessionId: string, value: string): void {
  try {
    if (value.trim() === '') {
      sessionStorage.removeItem(PREFIX + sessionId);
    } else {
      sessionStorage.setItem(PREFIX + sessionId, value);
    }
  } catch {
    // См. комментарий в readDraft.
  }
}

export function clearDraft(sessionId: string): void {
  saveDraft(sessionId, '');
}
